export default {
  LOCALIZATION: 'localization',
  APP_THEME: 'app_theme',
};
